var ezdia;
(function (ezdia) {
    // eslint-disable-next-line import/prefer-default-export
    var Http = /** @class */ (function () {
        function Http() {
        }
        Http.get = function (props) {
            return new Promise(function (resolve, reject) {
                $.ajax(__assign(__assign({ type: 'GET', dataType: 'json' }, props), { success: function (response) {
                        if (response.success) {
                            resolve(response);
                        }
                        else {
                            reject(response);
                        }
                    },
                    error: function (response) {
                        reject(response);
                    } }));
            });
        };
        Http.post = function (props) {
            return new Promise(function (resolve, reject) {
                $.ajax(__assign(__assign({ type: 'POST', dataType: 'json' }, props), { success: function (response) {
                        var success = response.success;
                        if (typeof response === 'string') {
                            resolve(response.trim());
                        }
                        else if (typeof success !== 'undefined' && !success) {
                            reject(response);
                        }
                        else {
                            resolve(response);
                        }
                    },
                    error: function (response) {
                        reject(response);
                    } }));
            });
        };
        return Http;
    }());
    ezdia.Http = Http;
})(ezdia || (ezdia = {}));
